import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/logo.png'
import { AnchorLink } from "gatsby-plugin-anchor-links";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: 'is-active',
            })
          : this.setState({
              navBarActiveClass: '',
            })
      }
    )
  }

  render() {
    return (
      <nav className="navbar is-transparent" role="navigation" aria-label="main-navigation">
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" title="Logo">
              <img src={logo} alt="Santa dash logo" style={{ width: '160px' }} />
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <Link className="navbar-item" to="/">
                HOME
              </Link>
              <AnchorLink className="navbar-item" to="/#information">
                INFORMATION
              </AnchorLink>
              <AnchorLink className="navbar-item" to="/#sponsor">
                ROCKING HORSE
              </AnchorLink>
			  <AnchorLink className="navbar-item" to="/#contact">
                CONTACT
              </AnchorLink>
              <AnchorLink className="navbar-item" to="/#training">
                GET IN SHAPE
              </AnchorLink>
            </div>
            <div className="navbar-end">
			<div className="navbar-item">
					<div className="field is-grouped">
						<p className="control">
							<a className="button is-primary" href={this.props.entryUrl} target="_blank" rel="noopener noreferrer">Enter now</a>
						</p>
					</div>
				</div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar
